import {
  Healthbox,
  HealthboxCreateData,
  HealthboxPaginatedResponse,
} from "@/types";
import { apiUrl } from "../../utils/url";
import { HttpClient } from "../HttpClient";
import { getErrorMessage } from "../errors";
import { IHealthboxService } from "./IHealthboxService";

export class HealthboxService implements IHealthboxService {
  private httpClient: HttpClient;

  constructor() {
    this.httpClient = new HttpClient({
      baseURL: apiUrl,
      timeout: 10000,
      headers: {},
    });
  }

  async getAll(
    page: number = 0,
    size: number = 10,
  ): Promise<HealthboxPaginatedResponse> {
    try {
      const queryParams = new URLSearchParams();
      if (page !== undefined && page !== null) {
        queryParams.append("page", page.toString());
      }
      if (size !== undefined && size !== null) {
        queryParams.append("size", size.toString());
      }

      const queryString = queryParams.toString();
      const endpoint = `/healthBox${queryString ? `?${queryString}` : ""}`;

      return await this.httpClient.get<HealthboxPaginatedResponse>(endpoint);
    } catch (error) {
      const errorMessage = getErrorMessage(
        error,
        "Não foi possível carregar os healthboxes. Atualize a página e tente novamente.",
      );
      throw new Error(errorMessage);
    }
  }

  async getById(id: number): Promise<Healthbox> {
    try {
      return await this.httpClient.get<Healthbox>(`/healthBox/${id}`);
    } catch (error) {
      const errorMessage = getErrorMessage(
        error,
        "Não foi possível carregar os healthboxes. Atualize a página e tente novamente.",
      );
      throw new Error(errorMessage);
    }
  }

  async search(query: string): Promise<Healthbox[]> {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append("healthbox name or sku value", query);
      const endpoint = `/healthBox/search?${queryParams.toString()}`;
      return await this.httpClient.get<Healthbox[]>(endpoint);
    } catch (error) {
      const errorMessage = getErrorMessage(
        error,
        "Não foi possível carregar os healthboxes. Atualize a página e tente novamente.",
      );
      throw new Error(errorMessage);
    }
  }

  async create(data: HealthboxCreateData): Promise<number> {
    try {
      const healthboxId = await this.httpClient.post<number>(
        "/healthBox/create",
        data,
        {},
        true,
      );
      return healthboxId;
    } catch (error) {
      const errorMessage = getErrorMessage(
        error,
        "Não foi possível criar a healthbox. Confirme os SKUs, itens obrigatórios e stock.",
      );
      throw new Error(errorMessage);
    }
  }

  async update(id: number, data: HealthboxCreateData): Promise<void> {
    try {
      await this.httpClient.put<void>(`/healthBox/${id}`, data);
    } catch (error) {
      const errorMessage = getErrorMessage(
        error,
        "Não foi possível criar a healthbox. Confirme os SKUs, itens obrigatórios e stock.",
      );
      throw new Error(errorMessage);
    }
  }

  async getByAttendeeId(
    attendeeId: number,
    page: number,
    size: number,
  ): Promise<HealthboxPaginatedResponse> {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append("page", String(page));
      queryParams.append("size", String(size));
      const endpoint = `/healthBox/attendee/${attendeeId}?${queryParams.toString()}`;
      return await this.httpClient.get<HealthboxPaginatedResponse>(endpoint);
    } catch (error) {
      const errorMessage = getErrorMessage(
        error,
        "Não foi possível carregar os healthboxes. Atualize a página e tente novamente.",
      );
      throw new Error(errorMessage);
    }
  }
}
